// LiveChat's launcher sits in the lower right corner, 84 by 84 px, above everything on the page. It covered the
// right end of the cart's Check out button, in the drawer and on the cart page, and it would cover the product
// page's bottom bar. While one of those reaches the corner, this script lifts the launcher just above it. With
// nothing to clear, or with the chat window open, the launcher stays where LiveChat puts it.
(() => {
  if (window.vvChatClearance) return;
  window.vvChatClearance = true;

  const LAUNCHER = 84;
  const GAP = 8;
  const root = document.documentElement;
  const style = document.createElement('style');
  style.textContent = 'html.vv-chat-lifted #chat-widget-container{bottom:var(--vv-chat-lift)!important}';
  document.head.appendChild(style);

  // The drawer's whole footer, the cart page's Terms box and Check out, and the product page's bottom bar.
  const targets = () => [
    document.querySelector('cart-drawer.active .drawer__footer'),
    document.querySelector('#checkout')?.closest('.cart__ctas'),
    document.querySelector('.vv-pdp-bar.is-visible'),
  ].filter(Boolean);

  const chatOpen = (chat) => {
    try {
      const state = window.LiveChatWidget?.get?.('state');
      if (state?.visibility) return state.visibility === 'maximized';
    } catch (error) { /* The size check below still holds. */ }
    return chat.offsetHeight > 2 * LAUNCHER;
  };

  // How far the launcher must rise so that its box clears every target that reaches into its corner.
  const liftNeeded = () => {
    const width = innerWidth;
    const height = innerHeight;
    let lift = 0;
    for (const target of targets()) {
      const rect = target.getBoundingClientRect();
      if (!rect.width || rect.right <= width - LAUNCHER || rect.left >= width) continue;
      if (rect.bottom <= height - LAUNCHER || rect.top >= height) continue;
      lift = Math.max(lift, Math.ceil(height - rect.top + GAP));
    }
    return lift;
  };

  let frame = 0;
  const update = () => {
    frame = 0;
    const chat = document.getElementById('chat-widget-container');
    const lift = chat && !chatOpen(chat) ? liftNeeded() : 0;
    root.classList.toggle('vv-chat-lifted', lift > 0);
    if (lift > 0) root.style.setProperty('--vv-chat-lift', `${lift}px`);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  document.addEventListener('vv:bottom-bar-change', schedule);
  document.addEventListener('transitionend', schedule, true);

  const watch = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    // The launcher arrives a few seconds after the page; its container's style changes when the chat opens.
    const attach = (chat) => {
      new MutationObserver(schedule).observe(chat, { attributes: true, attributeFilter: ['style'] });
      schedule();
    };
    const existing = document.getElementById('chat-widget-container');
    if (existing) {
      attach(existing);
    } else {
      const body = new MutationObserver(() => {
        const chat = document.getElementById('chat-widget-container');
        if (!chat) return;
        body.disconnect();
        attach(chat);
      });
      body.observe(document.body, { childList: true, subtree: true });
    }
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
})();
